/**
 * DIME-STYLE PRODUCT PAGE - JAVASCRIPT
 * Handles: Modal interactions, size selection, variant changes, add to cart, accordions
 */
(function() {
  'use strict';
  // ============================================
  // GLOBAL STATE
  // ============================================
  let productData = null;
  let selectedVariant = null;
  // ============================================
  // INITIALIZATION
  // ============================================
  function init() {
    // Load product data
    loadProductData();
    
    // Set initial variant
    setInitialVariant();
    
    // Initialize event listeners
    initModalListeners();
    initSizeSelectionListeners();
    initAccordionListeners();
    initTypeSelectionListeners();
    initAddToCartListeners();
  }
  // ============================================
  // LOAD PRODUCT DATA
  // ============================================
  function loadProductData() {
    const productJSON = document.getElementById('productJSON');
    if (productJSON) {
      try {
        productData = JSON.parse(productJSON.textContent);
        console.log('Product data loaded:', productData);
      } catch (error) {
        console.error('Error parsing product JSON:', error);
      }
    }
  }
  // ============================================
  // SET INITIAL VARIANT
  // ============================================
  function setInitialVariant() {
    if (!productData || !productData.variants) return;
    
    // Find first available variant or just the first variant
    selectedVariant = productData.variants.find(v => v.available) || productData.variants[0];
  }
  // ============================================
  // MODAL LISTENERS
  // ============================================
  function initModalListeners() {
    const modal = document.getElementById('sizeModal');
    const openBtnDesktop = document.getElementById('openSizeModal');
    const openBtnMobile = document.getElementById('openSizeModalMobile');
    const closeBtn = document.getElementById('closeModal');
    const overlay = document.getElementById('modalOverlay');
    if (!modal) return;
    // Open modal - Desktop
    if (openBtnDesktop) {
      openBtnDesktop.addEventListener('click', () => openModal());
    }
    // Open modal - Mobile
    if (openBtnMobile) {
      openBtnMobile.addEventListener('click', () => openModal());
    }
    // Close modal
    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeModal());
    }
    // Close modal on overlay click
    if (overlay) {
      overlay.addEventListener('click', () => closeModal());
    }
    // Close modal on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
  }
  function openModal() {
    const modal = document.getElementById('sizeModal');
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeModal() {
    const modal = document.getElementById('sizeModal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  // ============================================
  // SIZE SELECTION LISTENERS
  // ============================================
  function initSizeSelectionListeners() {
    const sizeOptions = document.querySelectorAll('.pdp-size-option');
    
    sizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        if (this.disabled) return;
        const variantId = this.getAttribute('data-variant-id');
        const variantTitle = this.getAttribute('data-variant-title');
        const variantPrice = this.getAttribute('data-variant-price');
        // Update selected variant
        if (productData && productData.variants) {
          selectedVariant = productData.variants.find(v => v.id == variantId);
        }
        // Update UI
        updateSizeSelection(this);
        updateVariantDisplay(variantTitle, variantPrice);
        updateAddToCartButton();
        // Close modal after selection
        setTimeout(() => closeModal(), 200);
      });
    });
  }
  function updateSizeSelection(selectedOption) {
    // Remove active class from all options
    document.querySelectorAll('.pdp-size-option').forEach(opt => {
      opt.classList.remove('active');
    });
    // Add active class to selected option
    selectedOption.classList.add('active');
  }
  function updateVariantDisplay(title, price) {
    // Update variant button text (desktop)
    const variantTextDesktop = document.querySelector('.pdp-variant-btn .pdp-variant-text');
    if (variantTextDesktop) {
      variantTextDesktop.textContent = title;
    }
    // Update variant button text (mobile)
    const variantTextMobile = document.querySelector('.pdp-variant-btn-mobile .pdp-variant-text');
    if (variantTextMobile) {
      variantTextMobile.textContent = title;
    }
    // Update desktop price
    const priceDesktop = document.querySelector('.pdp-atc-price');
    if (priceDesktop) {
      priceDesktop.textContent = price;
    }
    // Update mobile price
    const priceMobile = document.querySelector('.pdp-add-to-cart-mobile span');
    if (priceMobile) {
      priceMobile.textContent = price;
    }
  }
  function updateAddToCartButton() {
    const btnDesktop = document.getElementById('addToCartBtn');
    const btnMobile = document.getElementById('addToCartBtnMobile');
    if (selectedVariant && selectedVariant.available) {
      // Enable buttons
      if (btnDesktop) {
        btnDesktop.disabled = false;
        btnDesktop.querySelector('.pdp-atc-text').textContent = 'Add to Cart';
      }
      if (btnMobile) {
        btnMobile.disabled = false;
      }
    } else {
      // Disable buttons
      if (btnDesktop) {
        btnDesktop.disabled = true;
        btnDesktop.querySelector('.pdp-atc-text').textContent = 'Sold Out';
      }
      if (btnMobile) {
        btnMobile.disabled = true;
      }
    }
  }
  // ============================================
  // TYPE SELECTION LISTENERS
  // ============================================
  function initTypeSelectionListeners() {
    const typeButtons = document.querySelectorAll('.pdp-type-btn');
    
    typeButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Remove active class from all buttons
        typeButtons.forEach(btn => btn.classList.remove('active'));
        
        // Add active class to clicked button
        this.classList.add('active');
        
        // Get selected type
        const selectedType = this.getAttribute('data-type');
        console.log('Selected type:', selectedType);
        
        // You can add custom logic here to filter variants or update product
        // For example, you might want to show/hide certain variants based on type
      });
    });
  }
  // ============================================
  // ACCORDION LISTENERS
  // ============================================
  function initAccordionListeners() {
    const accordions = document.querySelectorAll('.pdp-accordion');
    
    accordions.forEach(accordion => {
      const header = accordion.querySelector('.pdp-accordion-header');
      
      if (header) {
        header.addEventListener('click', () => {
          // Toggle active class
          accordion.classList.toggle('active');
          
          // Close other accordions (optional - remove for multiple open)
          // accordions.forEach(acc => {
          //   if (acc !== accordion) {
          //     acc.classList.remove('active');
          //   }
          // });
        });
      }
    });
  }
  // ============================================
  // ADD TO CART LISTENERS
  // ============================================
  function initAddToCartListeners() {
    const btnDesktop = document.getElementById('addToCartBtn');
    const btnMobile = document.getElementById('addToCartBtnMobile');
    if (btnDesktop) {
      btnDesktop.addEventListener('click', () => addToCart());
    }
    if (btnMobile) {
      btnMobile.addEventListener('click', () => addToCart());
    }
  }
  function addToCart() {
    if (!selectedVariant || !selectedVariant.available) {
      console.error('No variant selected or variant unavailable');
      return;
    }
    const formData = {
      items: [{
        id: selectedVariant.id,
        quantity: 1
      }]
    };
    // Show loading state
    setAddToCartLoading(true);
    // Add to cart via Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);
      
      // Reset loading state
      setAddToCartLoading(false);
      
      // Update cart drawer or redirect - implement based on your theme
      // For now, just update the cart count and show success
      updateCartCount();
      showAddToCartSuccess();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      setAddToCartLoading(false);
      alert('Error adding to cart. Please try again.');
    });
  }
  function setAddToCartLoading(isLoading) {
    const btnDesktop = document.getElementById('addToCartBtn');
    const btnMobile = document.getElementById('addToCartBtnMobile');
    if (isLoading) {
      if (btnDesktop) {
        btnDesktop.disabled = true;
        btnDesktop.querySelector('.pdp-atc-text').textContent = 'Adding...';
      }
      if (btnMobile) {
        btnMobile.disabled = true;
      }
    } else {
      if (btnDesktop) {
        btnDesktop.disabled = false;
        btnDesktop.querySelector('.pdp-atc-text').textContent = 'Add to Cart';
      }
      if (btnMobile) {
        btnMobile.disabled = false;
      }
    }
  }
  function updateCartCount() {
    // Fetch updated cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart updated:', cart);
        
        // Update cart count in header (if you have one)
        const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  function showAddToCartSuccess() {
    // Simple success feedback - you can customize this
    const btnDesktop = document.getElementById('addToCartBtn');
    const btnMobile = document.getElementById('addToCartBtnMobile');
    if (btnDesktop) {
      const originalText = btnDesktop.querySelector('.pdp-atc-text').textContent;
      btnDesktop.querySelector('.pdp-atc-text').textContent = 'Added!';
      
      setTimeout(() => {
        btnDesktop.querySelector('.pdp-atc-text').textContent = originalText;
      }, 2000);
    }
    // You can also trigger a cart drawer to open here if your theme has one
    // Example: document.dispatchEvent(new CustomEvent('cart:open'));
  }
  // ============================================
  // RUN ON DOM READY
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
